const ScrollTrackingHook = {
  mounted() {
    this.currentSection = null;
    this.sectionElements = new Map();
    this.tocElements = new Map();
    
    // Initialize section and TOC element mappings with a small delay to ensure DOM is ready
    this.initializationTimer = setTimeout(() => {
      this.initializationTimer = null;
      this.initializeElements();
      
      // Add scroll listener
      this.scrollHandler = this.handleScroll.bind(this);
      window.addEventListener('scroll', this.scrollHandler, { passive: true });
      
      // Initial scroll check
      this.handleScroll();
    }, 100);
  },
  
  destroyed() {
    if (this.initializationTimer) {
      clearTimeout(this.initializationTimer);
      this.initializationTimer = null;
    }

    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
      this.scrollHandler = null;
    }
  },
  
  initializeElements() {
    // Find all section elements
    const sections = document.querySelectorAll('[id^="section-"]');
    sections.forEach(section => {
      const sectionId = section.id.replace('section-', '');
      this.sectionElements.set(sectionId, section);
    });
    
    // Find all TOC elements
    const tocItems = document.querySelectorAll('[id^="toc-section-"]');
    tocItems.forEach(tocItem => {
      const sectionId = tocItem.id.replace('toc-section-', '');
      this.tocElements.set(sectionId, tocItem);
    });
  },
  
  handleScroll() {
    const scrollTop = window.pageYOffset;
    const windowHeight = window.innerHeight;
    const scrollMiddle = scrollTop + windowHeight / 2;
    
    let currentSection = null;
    let minDistance = Infinity;
    
    // Find the section closest to the center of the viewport
    this.sectionElements.forEach((element, sectionId) => {
      const rect = element.getBoundingClientRect();
      const elementTop = rect.top + scrollTop;
      const elementBottom = elementTop + rect.height;
      
      // Check if section is in view
      if (elementTop <= scrollMiddle && elementBottom >= scrollMiddle) {
        const distance = Math.abs(elementTop + rect.height / 2 - scrollMiddle);
        if (distance < minDistance) {
          minDistance = distance;
          currentSection = sectionId;
        }
      }
    });
    
    // Update TOC highlighting
    this.updateTocHighlighting(currentSection);
  },
  
  updateTocHighlighting(sectionId) {
    if (this.currentSection === sectionId) return;
    
    // Remove previous highlighting
    if (this.currentSection && this.tocElements.has(this.currentSection)) {
      const prevTocItem = this.tocElements.get(this.currentSection);
      prevTocItem.classList.remove('border-l-4', 'border-l-green-500', 'bg-green-50', 'dark:bg-green-900/20');
      prevTocItem.classList.add('border-l', 'border-l-transparent');
    }
    
    // Add new highlighting
    if (sectionId && this.tocElements.has(sectionId)) {
      const currentTocItem = this.tocElements.get(sectionId);
      currentTocItem.classList.remove('border-l', 'border-l-transparent');
      currentTocItem.classList.add('border-l-4', 'border-l-green-500', 'bg-green-50', 'dark:bg-green-900/20');
      
      // Scroll TOC to show the current section
      this.scrollTocToSection(currentTocItem);
    }
    
    this.currentSection = sectionId;
  },
  
  scrollTocToSection(tocElement) {
    const tocContainer = document.getElementById('toc-sections-list');
    if (!tocContainer) return;
    
    const containerRect = tocContainer.getBoundingClientRect();
    const elementRect = tocElement.getBoundingClientRect();
    
    // Check if element is outside the visible area
    if (elementRect.top < containerRect.top || elementRect.bottom > containerRect.bottom) {
      tocElement.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest'
      });
    }
  }
};

export default ScrollTrackingHook;
